import type { ShowConsultation } from '../components/ConsultationTabSections/ShowConsultation';

export const getPaymentTypeText = ({
  consultation,
  ffEnableShopifyPayment
}: {
  consultation: ShowConsultation;
  ffEnableShopifyPayment: boolean;
}) => {
  if (ffEnableShopifyPayment) {
    if (!consultation?.payment_status) {
      return '-';
    }

    return 'Credit Card / Bank Transfer';
  }
  if (consultation?.payment_id) {
    return 'Credit Card (upfront)';
  }
  if (consultation?.paymentStatus?.preAuthTransactionExists) {
    return 'Credit Card';
  }
  return 'Invoice';
};
